'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPersons$0024package$0024$002dPet$00241 from "./samples.-Persons$package$-Pet$1.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$18(evaluator$27) {
  this.Lr = null;
  this.Lr = evaluator$27;
}
export { $c_Lsamples_Persons$package$$anon$18 as $c_Lsamples_Persons$package$$anon$18 };
$p = $c_Lsamples_Persons$package$$anon$18.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$18;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$18() {
}
export { $h_Lsamples_Persons$package$$anon$18 as $h_Lsamples_Persons$package$$anon$18 };
$h_Lsamples_Persons$package$$anon$18.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lr.h();
  return ((v instanceof $j_samples$002e$002dPersons$0024package$0024$002dPet$00241.$c_Lsamples_Persons$package$Pet$1) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$18 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$18, "samples.Persons$package$$anon$18", ({
  py: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$18 as $d_Lsamples_Persons$package$$anon$18 };
